import type { Key } from 'react';
import { useCallback, useMemo } from 'react';
import { useAtom } from 'jotai';
import { useSidePanel } from '../../../side-panel/side-panel-provider';
type PropsT = {
  allSectionKeys: Key[];
};
type ResultT = {
  expandedKeys: Key[];
  setExpandedKeys: (updater: Key[] | ((prev: Key[]) => Key[])) => void;
};
export const useAnnotationSectionExpansion = ({
  allSectionKeys
}: PropsT): ResultT => {
  const {
    expandedAnnotationSectionIdsAtom
  } = useSidePanel();
  const [collapsedSectionIds, setCollapsedSectionIds] = useAtom(expandedAnnotationSectionIdsAtom);
  const expandedKeys = useMemo(() => allSectionKeys.filter(key => !collapsedSectionIds.has(key)), [allSectionKeys, collapsedSectionIds]);
  const setExpandedKeys = useCallback((updater: Key[] | ((prev: Key[]) => Key[])) => {
    const nextExpandedKeys = typeof updater === 'function' ? updater(expandedKeys) : updater;
    const nextExpandedSet = new Set(nextExpandedKeys);
    const nextCollapsed = new Set<Key>(allSectionKeys.filter(key => !nextExpandedSet.has(key)));
    setCollapsedSectionIds(nextCollapsed);
  }, [allSectionKeys, expandedKeys, setCollapsedSectionIds]);
  return {
    expandedKeys,
    setExpandedKeys
  };
};